import { NAV_CHANGED } from "../types";

export const navChanged = nav => ({
  type: NAV_CHANGED,
  nav
});

export const stickyNavIndexChanged = currentIndex => dispatch => {
  dispatch(navChanged({ currentIndex }));
};



// WEBPACK FOOTER //
// ./src/actions/nav.js